import React from "react";

const HeroBlock = ({ titleText }) => {
  return (
    <div className="main-hero">
      <picture className="hero-bg">
        <source
          media="(max-width: 767px)"
          srcSet="/images/hero/hero-mobile.webp"
          width="768"
          height="146"
        />
        <img
          src="/images/hero/hero.webp"
          alt=""
          fetchpriority="high"
          decoding="async"
          width="1920"
          height="196"
        />
      </picture>

      <div className="container">
        <h1 className="title">{titleText}</h1>
      </div>
    </div>
  );
};

export default HeroBlock;
